/* eslint-disable react/jsx-props-no-spreading -- the server props are the component contract */
import React from 'react';
import I18n from '@utils/i18n';
import VisitsSection from '../../Visits';
import { VisitsMode } from '../../Visits/types';
/** The New page's scheduled date input (`text_field_tag 'date[date]'`), MM/DD/YYYY. */
const SCHEDULED_DATE_INPUT_ID = 'date[date]';
/**
 * The New page's primary visit time zone select. The shared component's own hidden inputs are named
 * `additional_visits[n][time_zone_override]`, so they are excluded.
 */
const TIME_ZONE_SELECT_SELECTOR = 'select[name$="[time_zone_override]"]:not([name^="additional_visits"])';
/** Reads the form's own date and zone when Add is clicked; the zone only counts if it is one of the options. */
export const readNewFormDefaults = (timeZoneOptions) => {
    var _a, _b, _c;
    const date = (_b = (_a = document.getElementById(SCHEDULED_DATE_INPUT_ID)) === null || _a === void 0 ? void 0 : _a.value) === null || _b === void 0 ? void 0 : _b.trim();
    const zone = (_c = document.querySelector(TIME_ZONE_SELECT_SELECTOR)) === null || _c === void 0 ? void 0 : _c.value;
    const knownZone = zone && (timeZoneOptions === null || timeZoneOptions === void 0 ? void 0 : timeZoneOptions.some((option) => option.value === zone)) ? zone : undefined;
    return { scheduledDate: date || undefined, timeZone: knownZone };
};
function AdditionalVisits(props) {
    const { defaults, timeZoneOptions } = props;
    const readsNewForm = defaults.scheduledDate === null;
    return (React.createElement(VisitsSection, Object.assign({}, props, { mode: VisitsMode.FORM, title: I18n.t('inspections.form.additional_visits.title'), getFormDefaults: readsNewForm ? () => readNewFormDefaults(timeZoneOptions) : undefined })));
}
export default AdditionalVisits;
